module.exports = __webpack_public_path__ + "img/1.450324b3.png";